export var DurationEnum;
(function (DurationEnum) {
    DurationEnum["Undetermined"] = "UNDETERMINED";
    DurationEnum["LessOneMonth"] = "LESSONEMONTH";
    DurationEnum["OneAndThreeMonths"] = "ONEANDTHREEMONTHS";
    DurationEnum["FourAndSixMonths"] = "FOURANDSIXMONTHS";
    DurationEnum["SevenAndTwelveMonths"] = "SEVENANDTWELVEMONTHS";
    DurationEnum["ThirteenAndTwentyFourMonths"] = "THIRTEENANDTWENTYFOURMONTHS";
    DurationEnum["TwentyFiveAndThirtySixMonths"] = "TWENTYFIVEANDTHIRTYSIXMONTHS";
})(DurationEnum || (DurationEnum = {}));
//# sourceMappingURL=duration.enum.js.map